import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from './useAdmin';

/**
 * Route guard: renders children when the session cookie is valid; otherwise
 * redirects to `/admin/login`. Shows a centered spinner while the initial
 * `/v1/admin/me` probe is in flight.
 */
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { status } = useAdmin();
  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-ink text-slate-400">
        <span className="text-sm">Loading…</span>
      </div>
    );
  }
  if (status === 'out') {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}
